import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { computed, observable, runInAction } from "mobx";
import { EProductPlanPaymentInterval, routeLocationPaddleProductPlanGet } from "@devowl-wp/api-real-commerce";
import { RealCommerceError } from "../exceptions/realCommerceError.js";
import { localizePaymentInterval } from "../others/localizePaymentInterval.js";
import { __ } from "../utils/i18n.js";
import { realCommerceRequest } from "../utils/realCommerceRequest.js";
class Product {
    get websiteCount() {
        var _this_data_productPlan_description_match, _this_data_productPlan_description;
        return +(((_this_data_productPlan_description = this.data.productPlan.description) == null ? void 0 : (_this_data_productPlan_description_match = _this_data_productPlan_description.match(/(\d+)+ website/i)) == null ? void 0 : _this_data_productPlan_description_match[1]) || 0);
    }
    get isOneTime() {
        return this.data.productPlan.paymentInterval === EProductPlanPaymentInterval.OneTime;
    }
    get labelPaymentInterval() {
        if (!this.data) {
            return "";
        }
        return localizePaymentInterval(this.data.productPlan.paymentInterval);
    }
    // @TODO: dynamically get from REST API and move to product model
    get seller() {
        return {
            name: "Paddle.com",
            link: __("https://paddle.com"),
            terms: __("https://paddle.com/legal-buyers"),
            privacy: __("https://paddle.com/privacy-buyers")
        };
    }
    // @TODO: dynamically get from REST API and move to product model
    get manufacturer() {
        return {
            name: "devowl.io GmbH",
            link: __("https://devowl.io/"),
            terms: __("https://devowl.io/terms/"),
            cancellation: __("https://devowl.io/cancellation-policy/"),
            privacy: __("https://devowl.io/privacy-policy/"),
            support: __("https://devowl.io/support/"),
            supportDpa: __("https://devowl.io/dpa-support/")
        };
    }
    constructor(data, store){
        this.store = store;
        runInAction(()=>{
            this.data = data;
        });
    }
    /**
     * Load the backend data from backend.
     *
     * @param params
     * @param store
     */ static async loadProduct(params, store) {
        let result;
        try {
            result = await realCommerceRequest({
                location: routeLocationPaddleProductPlanGet,
                params
            });
        } catch (e) {
            throw new RealCommerceError(e);
        }
        return new Product(result, store);
    }
}
_ts_decorate([
    observable,
    _ts_metadata("design:type", typeof IRouteResponsePaddleProductPlanGet === "undefined" ? Object : IRouteResponsePaddleProductPlanGet)
], Product.prototype, "data", void 0);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], Product.prototype, "websiteCount", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], Product.prototype, "isOneTime", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", void 0)
], Product.prototype, "labelPaymentInterval", null);
export { Product };
